<template>
  <div>
    <IntroCard></IntroCard>
  </div>
</template>

<script>
import IntroCard from "@/components/IntroCard";

export default {
  components: {
    IntroCard
  },
  title: "Kieran Small"
};
</script>

<style lang="scss" scoped></style>
